import { isMobile } from '../../utils';
export var viewModalOnMobile = {
  name: 'viewModalOnMobile',
  enabled: true,
  phase: 'beforeWrite',
  fn: function fn(_ref) {
    var state = _ref.state;

    if (isMobile()) {
      state.styles.popper = {
        left: '0',
        right: '0',
        top: '0',
        bottom: '0',
        transform: 'none'
      };
    }
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21tb24vVG9vbHRpcC9tb2RpZmllcnMudHMiXSwibmFtZXMiOlsiaXNNb2JpbGUiLCJ2aWV3TW9kYWxPbk1vYmlsZSIsIm5hbWUiLCJlbmFibGVkIiwicGhhc2UiLCJmbiIsInN0YXRlIiwic3R5bGVzIiwicG9wcGVyIiwibGVmdCIsInJpZ2h0IiwidG9wIiwiYm90dG9tIiwidHJhbnNmb3JtIl0sIm1hcHBpbmdzIjoiQUFDQSxTQUFTQSxRQUFULFFBQXlCLGFBQXpCO0FBRUEsT0FBTyxJQUFNQyxpQkFBb0QsR0FBRztBQUNsRUMsRUFBQUEsSUFBSSxFQUFFLG1CQUQ0RDtBQUVsRUMsRUFBQUEsT0FBTyxFQUFFLElBRnlEO0FBR2xFQyxFQUFBQSxLQUFLLEVBQUUsYUFIMkQ7QUFJbEVDLEVBQUFBLEVBSmtFLG9CQUlwRDtBQUFBLFFBQVRDLEtBQVMsUUFBVEEsS0FBUzs7QUFDWixRQUFJTixRQUFRLEVBQVosRUFBZ0I7QUFDZE0sTUFBQUEsS0FBSyxDQUFDQyxNQUFOLENBQWFDLE1BQWIsR0FBc0I7QUFDcEJDLFFBQUFBLElBQUksRUFBRSxHQURjO0FBRXBCQyxRQUFBQSxLQUFLLEVBQUUsR0FGYTtBQUdwQkMsUUFBQUEsR0FBRyxFQUFFLEdBSGU7QUFJcEJDLFFBQUFBLE1BQU0sRUFBRSxHQUpZO0FBS3BCQyxRQUFBQSxTQUFTLEVBQUU7QUFMUyxPQUF0QjtBQU9EO0FBQ0Y7QUFkaUUsQ0FBN0QiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBNb2RpZmllciB9IGZyb20gJ0Bwb3BwZXJqcy9jb3JlL2xpYi9wb3BwZXItbGl0ZSc7XG5pbXBvcnQgeyBpc01vYmlsZSB9IGZyb20gJy4uLy4uL3V0aWxzJztcblxuZXhwb3J0IGNvbnN0IHZpZXdNb2RhbE9uTW9iaWxlOiBNb2RpZmllcjwndmlld01vZGFsT25Nb2JpbGUnLCB7fT4gPSB7XG4gIG5hbWU6ICd2aWV3TW9kYWxPbk1vYmlsZScsXG4gIGVuYWJsZWQ6IHRydWUsXG4gIHBoYXNlOiAnYmVmb3JlV3JpdGUnLFxuICBmbih7IHN0YXRlIH0pIHtcbiAgICBpZiAoaXNNb2JpbGUoKSkge1xuICAgICAgc3RhdGUuc3R5bGVzLnBvcHBlciA9IHtcbiAgICAgICAgbGVmdDogJzAnLFxuICAgICAgICByaWdodDogJzAnLFxuICAgICAgICB0b3A6ICcwJyxcbiAgICAgICAgYm90dG9tOiAnMCcsXG4gICAgICAgIHRyYW5zZm9ybTogJ25vbmUnXG4gICAgICB9O1xuICAgIH1cbiAgfVxufTtcbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./~/@utex/ui-kit/dist/common/Tooltip/modifiers.js
// module id = 1675
// module chunks = 118